import React from 'react';
import { QueryVal } from 'Helpers/Query';
import SetNewPassword from './SetNewPassword';
import PasswordResetEmailForm from './PasswordResetEmailForm';

const NewPasswordReset = (props) => {
  const token = QueryVal('t');

  if (token) {
    return (<SetNewPassword {...props} />);
  }

  return (<PasswordResetEmailForm {...props} />);
};

export default NewPasswordReset;
